// SEROTA Yönetim (admin) ortak tipleri (A01–A19). Alan dosyaları: admin-business.ts (firmalar, abonelik, bayrak, maliyet,
// beyaz etiket) ve admin-platform.ts (canlı operasyon, GPS, destek, güvenlik, KVKK, sürüm, şablon, sistem).
import { z } from 'zod';
import type { TenantType } from '../enums';

export const TENANT_TYPE_LABELS: Record<TenantType, string> = {
  SERVICE_COMPANY: 'Servis firması',
  INSTITUTION: 'Kurum',
  PLATFORM: 'Platform',
};

export const COMPANY_STATUSES = ['ACTIVE', 'TRIAL', 'SUSPENDED'] as const;
export type CompanyStatus = (typeof COMPANY_STATUSES)[number];
export const COMPANY_STATUS_LABELS: Record<CompanyStatus, string> = {
  ACTIVE: 'Etkin',
  TRIAL: 'Deneme',
  SUSPENDED: 'Askıda',
};

export const AdminSearchQuery = z.object({ q: z.string().trim().min(2).max(60) });

export interface AdminSearchHit {
  id: string;
  name: string;
  type: TenantType;
  status: CompanyStatus;
}

export interface AdminSearchResult {
  companies: AdminSearchHit[];
}

/**
 * Bağlam değişti olayı: bayrak, plan veya firma durumu değiştiğinde `company:<id>` kanalına yayınlanır;
 * istemciler bağlamı (menü, sekme, izin) yeniden yükler. Yük kişisel veri taşımaz.
 */
export const CONTEXT_CHANGED_EVENT = 'context.changed';

// ───────── Sistem sağlığı özeti (A19 üretir, A01 gösterir) ─────────
export const HEALTH_LEVELS = ['ok', 'degraded', 'down'] as const;
export type HealthLevel = (typeof HEALTH_LEVELS)[number];
export const HEALTH_LEVEL_LABELS: Record<HealthLevel, string> = {
  ok: 'Çalışıyor',
  degraded: 'Kısmi sorun',
  down: 'Çalışmıyor',
};

export interface HealthCheck {
  /** api | db | postgis | redis | queues | realtime | gps-ingest | sms | email | push | map */
  key: string;
  label: string;
  level: HealthLevel;
  /** kısa açıklama: "12 ms", "3 iş başarısız", "mock sağlayıcı" */
  detail: string;
  latencyMs: number | null;
}

/** GET /v1/admin/system/summary */
export interface SystemHealthSummary {
  level: HealthLevel;
  checks: HealthCheck[];
  at: string;
}
